import React, { useState } from "react";
import { DocumentIcon, TableCellsIcon } from "@heroicons/react/24/outline";
import FileCardAdvies from "../../Componenten/MiniCards/FileCardAdvies";
import FilterNavigation from "../../Componenten/Dashboard/FilterNavigation";
import DashboardDocumenten from "../../Componenten/DashboardDocumenten";

const filters = [
  { value: 1, name: "list", icon: TableCellsIcon, color: "text-green-500" },
  { value: 2, name: "block", icon: DocumentIcon, color: "text-green-500" },
];

const PlansClient = ({
  userdetails,
  attachments,
}) => {
  const [view, setView] = useState(filters[0]);

  return (
    <div className="mx-auto h-full w-full bg-wa-app px-4 pt-6 sm:px-6 lg:px-8">
      <div className="flex items-center justify-between">
        <FilterNavigation
          selectedRadio={view}
          setSelectedRadio={setView}
          options={filters}
        />
      </div>
      {view?.value === 1 ? (
        <DashboardDocumenten
          attachments={attachments}
          type="advies"
          user={userdetails}
        />
      ) : (
        <div className="mt-4 grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3 xxl:grid-cols-4">
          {attachments?.length > 0 ? (
            attachments.map((item) => (
              <div key={item?.id || item?.url || item?.bestand}>
                <FileCardAdvies item={item} userdetails={userdetails} />
              </div>
            ))
          ) : (
            <div className="col-span-full rounded-lg border border-wa-border bg-wa-panel p-8 text-center text-wa-muted">
              <p>Er zijn geen documenten gevonden.</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PlansClient;
